import { SvgIcon } from '@mui/material';

const CheckCircleWhiteFilled = props => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z'
      fill='currentColor'
    />
    <path d='M10 17l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z' fill='#FFFFFF' />
  </SvgIcon>
);

export default CheckCircleWhiteFilled;
